import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { IoAlertCircleOutline } from "react-icons/io5";
import "./customstyles.css";

const PopUp = ({
  title,
  message,
  type,
  customPosL,
  customPosT,
  onClose,
  deleteCond,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFullyVisible, setIsFullyVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);

    return () => setIsVisible(false);
  }, []);

  const closePopUp = () => {
    setIsVisible(false); // Activa animación de salida
    setTimeout(() => {
      setIsFullyVisible(false); // Retrasa desmontaje hasta después de la animación
      if (onClose) onClose(); // Notifica al padre una vez que la animación termina
    }, 500); // Ajusta la duración del retraso según la duración de tu animación
  };

  // useEffect(() => {
  //   if (deleteCond == true) {
  //     closePopUp();
  //   }
  // }, [deleteCond]);

  if (!isFullyVisible) return null;

  return (
    <div
      className={`  relative fade-box  ${
        isVisible ? "fade-in" : "fade-out"
      } h-[0px]`}
    >
      <div
        className={` absolute ${
          !customPosT ? "top-[-130px]" : customPosT
        } z-20 ${
          !customPosL ? "left-[100px]" : customPosL
        }  flex flex-col rounded-xl p-4 shadow-2xl bg-white w-[300px] 
       
        `}
      >
        {onClose && (
          <div className="absolute right-[15px] top-[15px]">
            <button
              className="rounded-[50%] hover:bg-red-200 transition-all duration-100 p-1"
              onClick={closePopUp}
            >
              <IoMdClose className="w-[25px] h-[25px]" />
            </button>
          </div>
        )}
        <div className="flex flex-row items-center justify-start">
          {type == "alert" && (
            <div className="flex items-center justify-center">
              <IoAlertCircleOutline className="text-accent-green h-[30px] w-[30px]" />
            </div>
          )}
          <div className=" p-2 py-1">
            <h3 className="font-poppins text-dark-green text-base font-bold whitespace-nowrap">
              {title}
            </h3>
          </div>
        </div>
        <p className="font-poppins text-sm text-dark-green">{message}</p>
        <div
          className=" absolute z-30 left-[40px] bottom-[-14px] w-0 h-0 
  border-l-[10px] border-l-transparent
  border-t-[15px] border-t-[#ffffff]
  border-r-[10px] border-r-transparent drop-shadow-2xl"
        />
      </div>
    </div>
  );
};

export default PopUp;
